import { CalendarDays } from "lucide-react";
import type { ModuleSpec } from "../types";

export const calendarSpec: ModuleSpec = {
  id: "calendar",
  icon: CalendarDays,
  i18n: {
    namespace: "modules",
    titleKey: "calendar.title",
    descriptionKey: "calendar.description",
  },
  nav: {
    path: "/calendar",
    group: "run",
    order: 30,
  },
  permission: {
    action: "read",
    subject: "integration",
  },
  meta: {
    status: "active",
    description: "Manage event types, availability, and bookings",
  },
};
